import { ARCreditApplicationTransactionItemResultDto } from './ar-credit-application-transaction-item-result-dto';

export class ApplyAmountDataEntry {
    amount: number;
    appliedAmount: number; // final appliedAmount
    currentAppliedAmount: number; // All calculations with the line item editor
    remainingUnapplied: number;
    itemId: number;
    unappliedAmount: number;
    sourceLineItemCreditApp: ARCreditApplicationTransactionItemResultDto;
    targetLineItemCreditApps: Array<ARCreditApplicationTransactionItemResultDto>;
}
